import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminRateTypes,
  initializeRateAdminRateTypesScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminRateTypes,
  saveRateTypesTableState
} from "../../../redux/actions/RateAdmin/rateadminRateTypes";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import RateAdminRateTypes from '../../../component/RateAdmin/RateAdminRateTypes';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function RateAdminRateTypesScreen(props) {
  const {
    fetchRateAdminRateTypes,
    initRateAdminRateTypesScreen,
    showPageLevelLoader,
    rateAdminRateTypesListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminRateTypes,
    isRateAdminRateTypesExportError,
    isRateAdminRateTypesExportSuccess,
    isLoading,
    savedTableState,
    saveRateTypesTableState,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminRateTypesScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminRateTypes(savedParams);
    } else {
      fetchRateAdminRateTypes({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminRateTypes(props);
  };

  const handleTableStateChange = (tableState) => {
    saveRateTypesTableState(tableState);
  };

  const handleCreateRateAdminRateTypes = () => {
    navigate(APP_URLS.RATEADMIN_RATE_TYPES.CREATE);
  }
  const editRateAdminRateTypesRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATE_TYPES.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminRateTypes = {
    handleCreateRateAdminRateTypes,
    exportRateAdminRateTypes,
    isRateAdminRateTypesExportError,
    isRateAdminRateTypesExportSuccess,
    editRateAdminRateTypesRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchRateAdminRateTypess: loadLazyData,
    tableData: {
      columns: rateAdminRateTypesListview?.columns,
      rows: rateAdminRateTypesListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminRateTypes
        {...rateAdminRateTypes}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminRateTypesScreen: () => dispatch(initializeRateAdminRateTypesScreen()),
    fetchRateAdminRateTypes: (payload) => dispatch(fetchRateAdminRateTypes(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminRateTypes: (payload) => dispatch(exportRateAdminRateTypes(payload)),
    saveRateTypesTableState: (payload) => dispatch(saveRateTypesTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminRateTypesCreateSuccess: selectFromRateAdminRateTypesReducer(
      state,
      "isRateAdminRateTypesCreateSuccess"
    ),
    rateAdminRateTypesListview: selectFromRateAdminRateTypesReducer(
      state,
      "rateAdminRateTypesListview"
    ),
    showPageLevelLoader: selectFromRateAdminRateTypesReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminRateTypesReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminRateTypesReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminRateTypesReducer(
      state,
      "isFetchingGridData"
    ),
    isRateAdminRateTypesExportError: selectFromRateAdminRateTypesReducer(
      state,
      "isRateAdminRateTypesExportError"
    ),
    isRateAdminRateTypesExportSuccess: selectFromRateAdminRateTypesReducer(
      state,
      "isRateAdminRateTypesExportSuccess"
    ),
    savedTableState: selectFromRateAdminRateTypesReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminRateTypesReducer = (state, path) => {
  return selectRateAdminRateTypesReducer(state)[path];
};

const selectRateAdminRateTypesReducer = ({ rateadminRateTypesReducer }) => {
  return rateadminRateTypesReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminRateTypesScreen);
